import { Tab, Tabs } from '@op/opds.opux';
import { formatDate } from '../utils/formatter';
import message from '../messages/Message';
import '../App.css';
import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { FuturePricesRoute, CurrentPricesRoute } from '../utils/routes';
import { usePriceListContent } from '../context/PriceListContext';

const TabsView = () => {
  const [activeTab, setActiveTab] = useState(0);
  const navigate = useNavigate();
  const { response } = usePriceListContent();
  const { futureEffectiveDates } = response;
  const formattedFutureEffectiveDate = formatDate(futureEffectiveDates);


const isDateInTimeline = (comparisonDate) => {
    const futureTimeline = 2; // Two months
    const twoMonthsFromNow = new Date();
    twoMonthsFromNow.setMonth(twoMonthsFromNow.getMonth() + futureTimeline);

    if (comparisonDate <= twoMonthsFromNow) {
      return true;
    }
    return false;
  };
  const shouldShowFuturePricesTab = isDateInTimeline(new Date(futureEffectiveDates));

  const handleTabChange = (event, index) => {
    setActiveTab(index);
    if (index === 0) {
      navigate(CurrentPricesRoute);
    } else if (index === 1) {
      navigate(FuturePricesRoute);
    }
  };
  

  useEffect(() => {
    navigate(CurrentPricesRoute);
    // eslint-disable-next-line
  }, []);

  return (
      <div>
        <Tabs active={activeTab} onChange={handleTabChange}>
          <Tab label={message('catalog_current')}>
          {activeTab === 0}
          </Tab>
          {shouldShowFuturePricesTab && (
            <Tab label={message('catalog_upcoming').replace('futureEffectiveDate', formattedFutureEffectiveDate)}>
              {activeTab === 1}
            </Tab>
          )}
        </Tabs>
      </div>
    );
  };

export default TabsView;